// import subjectBbList from '../components/subjectBb/subjectBbList.vue'

export default [
    { 
        path: 'subjectBb/subjectBbList',
        component: resolve => require(['@/components/subjectBb/subjectBbList'],resolve),
        name:'SubjectBbList',
        meta:{
            id:'950',
            node:'subjectBb',
            url:'subjectBbList',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/subjectBb.js